import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../../utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter ? `, filter: ${convertFilterRequestUrl(filter, [])}` : '';
  const getUsageConsumptionReport = `getUsageConsumptionReport(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${getUsageConsumptionReport} {
        period
        accountId
        firstName
        lastName
        phoneNumber
        totalKwh
        totalAmount
      }
    }
  `;
};
